import styled from 'styled-components';

export const PageContainer = styled.div`
  height: 100%;
  overflow-y: scroll;
`;
